import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

export const cardTitleStyles = style({
	font: 'title',
	fontWeight: 'bold',
	fontSize: 'title-sm',
});

export const CARD =
	'bg-[#f8f8f8] border border-[rgba(255,255,255,0.4)] rounded-2xl p-6';

export const PILL_TAG =
	'rounded-lg bg-[#e9e9e9] px-3 py-1.5 text-sm font-medium text-[#131313]';
